import type { QuickshopConfig } from '#types/config/components/dialog/quickshop'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    stickyFooter: '<lg:space-y-2 lg:(grid cols-2 space-x-2)',
  },
  gallery: {
    presets: {
      src: {
        height: 527,
        width: 527
      }
    }
  }
} satisfies RecursivePartial<QuickshopConfig>
